import Vue from 'vue'

const env = {
  apiUrl: process.env.VUE_APP_API_URL || 'https://baseplate-api.test/api/v1',
}

Vue.prototype.$env = env

export default env
